
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {dispatchCreatePrinterLog, dispatchGetForm, dispatchGetFormValuesByID} from '@/store/main/actions';
import {
  readCurrentPrinterLog,
  readHasModuleAccess,
  readUserProfile,
} from '@/store/main/getters';
import VueQrcode from 'vue-qrcode';
import RendererPreviewContent from '@/components/forms/RendererPreviewContent.vue';
import {commitAddNotification} from '@/store/main/mutations';

@Component({
  components: {RendererPreviewContent, VueQrcode},
})
export default class Preview extends Vue {
  private formValueId: number = 0;
  private hasSignature: boolean = false;

  private get currentUser() {
    return readUserProfile(this.$store);
  }

  public async mounted() {

    const canAccessPage =  readHasModuleAccess(this.$store)({module: 'form_values', method: 'print'});

    if (!canAccessPage) {
      // @ts-ignore
      commitAddNotification(this.$store, {content: this.$t('notAllowed'), color: 'warning'});
      window.close();
    }

    this.formValueId = Number(this.$router.currentRoute.params.id);
    this.hasSignature = JSON.parse(this.$router.currentRoute.query?.has_signature as string) as unknown as boolean;
    await new Promise((resolve, reject) => setTimeout(() => resolve(), 1000));
    // await window.print();

    // @ts-ignore
    if (!this.currentUser || !this.formValueId) {
      console.error('User not defined');
      return;
    }

    await dispatchCreatePrinterLog(this.$store, {document_id: this.formValueId,
      created_by: this.currentUser?.id, has_signature: this.hasSignature});
    await new Promise((resolve, reject) => setTimeout(() => resolve(), 1000));

    if (!this.currentPrinterLogs) {
      // @ts-ignore
      commitAddNotification(this.$store, {content: this.$t('errors.cannot_sign_document'), color: 'error'});

    } else {
      await new Promise((resolve, reject) => setTimeout(() => resolve(), 1500));
      window.print();
    }
  }

  private get currentDate() {
    return new Date().toLocaleString('pt-br');
  }

  private get currentEmittedInstitution() {
    // @ts-ignore
    const hospitalName = this.currentUser?.role?.settings?.custom_data.find((e) => e?.name === 'hospital_name')?.value;
    return hospitalName ? hospitalName : '-----' ;
  }

  private get parsedDate() {
    if (!this.currentPrinterLogs?.created_at) {
      return '-----';
    }
    let currentDate = this.currentPrinterLogs?.created_at;
    if (typeof currentDate  === 'number') {
      currentDate *= 1000;
    }

    const date = new Date(currentDate);

    return date.toLocaleString('pt-br');

    // return `${date.getDate()}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}
    // ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;

  }

  private get currentPrinterLogs() {
    return readCurrentPrinterLog(this.$store);
  }

  private async printPdf() {
    window.print();
  }

}
